export abstract class ModelOptions {
    // class contains empty constructor so that tslint does not complain about the empty class
    public constructor() {
        // empty
    }
}

export abstract class JsonModelOptions extends ModelOptions {}
